"use client";

import { useState } from "react";
import { useParams } from "next/navigation";
import dynamic from "next/dynamic";

import type {
  ClickedFeature,
  OverlayStyleMap,
  SelectedIndicator,
} from "@/types/public/types";
import { MapStateProvider } from "@/contexts/public/MapStateContext";

const Map = dynamic(() => import("@/components/public/Map"), { ssr: false });

export default function Page() {
  const params = useParams<{ muniCode?: string }>();

  const muniCode = params?.muniCode ?? "28065";
  const tileBaseUrl = "https://tile.urbanstudio.es/data";

  const [panelHidden, setPanelHidden] = useState(false);
  const [clicked, setClicked] = useState<ClickedFeature | null>(null);
  const [selected, setSelected] = useState<SelectedIndicator | null>(null);
  const [overlayStyles, setOverlayStyles] = useState<OverlayStyleMap>({});
  const [otherSources, setOtherSources] = useState<Record<string, string>>({});

  return (
    <div className="h-dvh w-screen">
      <MapStateProvider
        value={{
          muniCode,
          tileBaseUrl,
          panelHidden,
          setPanelHidden,
          clicked,
          setClicked,
          selected,
          setSelected,
          otherSources,
          setOtherSources,
          overlayStyles,
          setOverlayStyles,
        }}
      >
        <Map />
      </MapStateProvider>
    </div>
  );
}
